import React from 'react';
import styled from 'styled-components';
import CameraDisabledIcon from '../common/Icons/CameraDisabled';
import Messages from '../../config/messages.constants';

const StyledVideoStoppedView = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;
const StyledCameraDisabledIcon = styled(CameraDisabledIcon)`
    min-width: 300px;
    min-height: 300px;
    width: calc(100vh * 0.3);
    height: calc(100vh * 0.3);
    color: rgba(255, 255, 255, 0.1);
`;

const VideoStoppedView: React.FunctionComponent = () => {
    return (
        <>
            <StyledVideoStoppedView>
                <StyledCameraDisabledIcon />
                <p className="text-xl error text-center mb-12">{Messages.CAMERA_TURNED_OFF}</p>
            </StyledVideoStoppedView>
        </>
    );
};

export default VideoStoppedView;
